/*
 * pj-store-join.js: the in-store sign-up page (sections/pj-store-join.liquid).
 * Reads ?store=<slug> from the boutique's QR code and:
 *   - names the boutique in the eyebrow ("Welcome to ParkerJoe · Rice Village");
 *   - adds the tag store-<slug> to the sign-up (Flow / segments use it);
 *   - lists that boutique's events first; the rest follow;
 *   - links to the boutique's own page (/pages/<slug>, sections/pj-boutique).
 * Only allow-listed slugs are used, so the URL can't inject tags.
 * Without JS the page works for every store.
 */
(function () {
  var root = document.querySelector('[data-pj-join]');
  if (!root) return;

  var STORES = {
    'rice-village': 'Rice Village',
    'sugar-land': 'Sugar Land',
    'the-woodlands': 'The Woodlands',
    'las-vegas': 'Las Vegas',
  };

  var success = root.querySelector('[data-pj-join-success]');
  if (success) success.focus();

  var slug = '';
  try { slug = (new URLSearchParams(window.location.search).get('store') || '').toLowerCase(); } catch (e) { slug = ''; }
  if (!Object.prototype.hasOwnProperty.call(STORES, slug)) return;
  var name = STORES[slug];

  var label = root.querySelector('[data-pj-join-store]');
  if (label) { label.textContent = ' · ' + name; label.hidden = false; }

  var boutique = root.querySelector('[data-pj-join-boutique]');
  if (boutique) {
    var link = boutique.querySelector('a');
    var text = boutique.querySelector('[data-pj-join-boutique-label]');
    if (link) link.setAttribute('href', '/pages/' + slug);
    if (text) text.textContent = (/^the /i.test(name) ? 'Visit ' : 'Visit the ') + name + ' page';
    boutique.hidden = false;
  }

  var tags = root.querySelector('[data-pj-join-tags]');
  if (tags && tags.value.indexOf('store-' + slug) === -1) tags.value += ',store-' + slug;

  var list = root.querySelector('[data-pj-join-events]');
  if (list) {
    var cards = Array.prototype.slice.call(list.children);
    var here = cards.filter(function (c) { return (c.getAttribute('data-store') || '') === name; });
    here.reverse().forEach(function (c) { list.insertBefore(c, list.firstChild); });
  }
})();
